import { Box, HStack, Link, Text, VStack } from "@chakra-ui/react";
import { APP_STORE_LINKS } from "../../constants/AppStoreLinks";

interface AppStoreButtonProps {
  onClick?: () => void;
}

const AppStoreButton = ({ onClick }: AppStoreButtonProps) => {
  const href = APP_STORE_LINKS.APP_STORE;

  const content = (
    <Box
      as={onClick ? "button" : "div"}
      display="flex"
      alignItems="center"
      px={4}
      py={2.5}
      borderRadius="lg"
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      boxShadow="0 2px 4px rgba(0, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.8)"
      _hover={{
        transform: "translateY(-1px)",
        boxShadow:
          "0 4px 8px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.9)",
        borderColor: "gray.300",
      }}
      _active={{
        transform: "translateY(0px)",
        boxShadow:
          "0 1px 2px rgba(0, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 0.8)",
      }}
      transition="all 0.2s ease"
      cursor="pointer"
      onClick={onClick}
    >
      <HStack spacing={3} align="center">
        {/* Apple Logo */}
        <Box
          w="28px"
          h="28px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.08-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
          </svg>
        </Box>

        {/* Text Content */}
        <VStack align="flex-start" spacing={0}>
          <Text fontSize="10px" lineHeight="1" color="gray.600" fontWeight="400">
            Download on the
          </Text>
          <Text
            fontSize="18px"
            lineHeight="1.2"
            color="gray.800"
            fontWeight="600"
            letterSpacing="-0.5px"
          >
            App Store
          </Text>
        </VStack>
      </HStack>
    </Box>
  );

  if (onClick) {
    return content;
  }

  return (
    <Link href={href} isExternal _hover={{ textDecoration: "none" }}>
      {content}
    </Link>
  );
};

export default AppStoreButton;

